import {} from 'vue';
const AppPlugin = (app, options) => {
    app.config.globalProperties.$lang = (...argArr) => {
        const key = argArr[0];
        const args = argArr.slice(1);
        return u.__(key, args);
    };
    app.config.globalProperties.$nl2br = (str) => {
        const breakTag = '<br />';
        const replaceStr = '$1' + breakTag;
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
    };
};
export default AppPlugin;
